import { type FC } from "react";
import { useMatch } from "react-router-dom";

import { DisplayComponent, Visible } from "../../common/components";
import { ActionDisabledTooltip, DisabledButtonToolipFix } from "../../common/components/ActionDisabledTooltip";
import { AccessContainer } from "../../common/containers/AccessContainer";
import { AddLensSourceContainer } from "../../lens-source/container";

import { PaneContainer, lensSourceButtonStyle, title } from "./TitlePane.styles";
import { AbsoluteRoute } from "../../../core/routes";

interface TitlePaneProps {
    onNewLensGroup: () => void;
}

export const TitlePane: FC<TitlePaneProps> = ({ onNewLensGroup }) => {
    const organizationGroupsMatch = useMatch(AbsoluteRoute.ORG_LENS_SCHEDULER_GROUPS);
    const organizationSourcesMatch = useMatch(AbsoluteRoute.ORG_LENS_SCHEDULER_SOURCES);

    return (
        <PaneContainer justifyContent="space-between">
            <h2 className={title}>Camera Kit</h2>
            <DisplayComponent show={organizationGroupsMatch != null}>
                <AccessContainer>
                    {({ permissions }) => (
                        <div>
                            <ActionDisabledTooltip placement="left" hasPermission={permissions?.updateGroups ?? false}>
                                <DisabledButtonToolipFix
                                    isElevated={true}
                                    type="primary"
                                    data-testid="add-groups-button"
                                    onClick={onNewLensGroup}
                                    isDisabled={!permissions?.updateGroups}
                                >
                                    New Lens Group
                                </DisabledButtonToolipFix>
                            </ActionDisabledTooltip>
                        </div>
                    )}
                </AccessContainer>
            </DisplayComponent>
            <Visible when={organizationSourcesMatch != null}>
                <AddLensSourceContainer buttonClassName={lensSourceButtonStyle} />
            </Visible>
        </PaneContainer>
    );
};
